import purify from "dompurify";

import { Text } from "@similarweb/ui-components/foundations";

import { DUNNINGS_INLINE_BANNER_CTA_LOCATION, NT_DUNNINGS_EVENT_NAME } from "app/components/Dunnings/dunningsConstants";
import { DunningsTextContactUsButton } from "app/components/Dunnings/DunningsModal/DunningsModalStyled";
import { DunningsLinkText } from "app/components/Dunnings/DunningsStyled";
import { useDunnings } from "app/components/hooks/useDunnings";
import { useTranslation } from "pro-features/components/WithTranslation";

export const ProjectsDunningsBannerText = () => {
    const { onContactUsClicked, isLastPaymentFailedWarning } = useDunnings();
    const translate = useTranslation();

    const onClick = () => onContactUsClicked(`${NT_DUNNINGS_EVENT_NAME}/${DUNNINGS_INLINE_BANNER_CTA_LOCATION}`)

    return (
        <div>
            <Text
                fontVariant="body2"
                dangerouslySetInnerHTML={{
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    __html: purify.sanitize(translate(isLastPaymentFailedWarning ? "dunnings.last_warning.projects.banner.text" : "dunnings.projects.banner.text")),
                }}
            />{" "}
            <DunningsTextContactUsButton onClick={onClick}>
                <DunningsLinkText
                    fontVariant="body2"
                    dangerouslySetInnerHTML={{
                        // eslint-disable-next-line @typescript-eslint/naming-convention
                        __html: purify.sanitize(translate("dunnings.projects.banner.contact_us")),
                    }}
                />
            </DunningsTextContactUsButton>
            {"."}
        </div>
    );
};
